export default __webpack_public_path__ + "images/76a38814262d7d0b2fbb68c7740130ca-halloween_seasonal_desktop.webp";